export const DEFAULT_ACTION = "app/SubmittedCases/DEFAULT_ACTION";
export const CASEDETAILS = "app/SubmittedCases/CASEDETAILS";